<template>
	<div class="box">
		<div>
			<div class="numDoctor">
				<div class="text1">
					<p>门诊注册总数</p>
					<p>{{zs}}</p>
				</div>
				<div class="text2">
					<p>今日新增</p>
					<p>{{jday}}</p>
				</div>
				<div class="text2">
					<p>七日新增</p>
					<p>{{day7}}</p>
				</div>
			</div>
			<div class="chartsDoc">
				<div class="chartsDocheader">
					<div>
						<el-date-picker
						    v-model="value1"
						    type="daterange"
						    range-separator="至"
						    start-placeholder="开始月份"
						    end-placeholder="结束月份"
						    value-format="yyyy-MM-dd"
						    @blur="dateFn()">
						    </el-date-picker>
					</div>
					<div class="datebtn">
						<div :class="btnStr==7?'active':''" @click="dayFn(7)">近7日</div>
						<div :class="btnStr==30?'active':''" @click="dayFn(30)">近30日</div>
					</div>
				</div>
				<div class="chartsDoccontent">
					<div>
						<charts :type="1" :options="options1" :datazs="mzzs"></charts>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import charts from '../component/charts.vue'
	import {mztj_count,mz_zczs} from '../components/http/api.js'
	export default{
		components:{
			charts
		},
		data(){
			return{
				value1:[],
				options1:[{
					id:1,
					name:'门诊注册总数',
				}],
				btnStr:7,
				zs:0,
				day7:0,
				jday:0,
				mzzs:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		               	data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'line',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)','#aaaaaa']
		        }
			}
		},
		mounted(){
			this.value1=[this.getDay(-7),this.getDay(0)];
			this.mztj_countFn();
			this.mz_zczsFn();
		},
		methods:{
			dayFn(i){
				this.btnStr=i;
				this.value1=[this.getDay(-i),this.getDay(0)];
				this.mz_zczsFn();
			},
			getDay(day){
			    var today = new Date();
			    var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
			    today.setTime(targetday_milliseconds); //注意，这行是关键代码
			    var tYear = today.getFullYear();
			    var tMonth = today.getMonth();
			    var tDate = today.getDate();
			    tMonth = this.doHandleMonth(tMonth + 1);
			    tDate = this.doHandleMonth(tDate);
			    return tYear+"-"+tMonth+"-"+tDate;
			},
			doHandleMonth(month){
			    var m = month;
			    if(month.toString().length == 1){
			     m = "0" + month;
			    }
			    return m;
			},
			dateFn(){
				this.mz_zczsFn();
			},
			mztj_countFn(){
				mztj_count().then(res=>{
					this.zs=res.yhryzcyh;
					this.day7=res.yhryzcyh_7t;
					this.jday=res.yhryzcyh_jt;
				})
			},
			mz_zczsFn(){
				var data={
					start_time:this.value1[0],
					end_time:this.value1[1]
				}
				mz_zczs(data).then(res=>{
					var arr1=res.ay_time;
					var arr2=res.ay_data;
					this.mzzs.xAxis.data=arr1;
					this.mzzs.series[0].data=arr2;
				})
			}
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: 100%;
	}
	.box>div{
		height: 364px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		/*background: #FFFFFF;*/
	}
	
	.box>div:nth-child(1){
		margin-bottom: 7px;
	}
	.numDoctor{
		width: 212px;
		height: 344px;
		padding:10px 20px;
		border-radius:3px;
		/*border-right: 3px solid rgba(198,198,198,1);*/
		background: #FFFFFF;
	}
	.text1,.text2{
		margin-bottom: 30px;
	}
	.text1>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text1>p:nth-child(2){
		font-size:30px;
		font-weight:600;
		color:rgba(74,74,74,1);
		margin-top: 8px;
		line-height:23px;
	}
	.text2>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text2>p:nth-child(2){
		margin-top: 8px;
		font-size:30px;
		font-weight:600;
		color:rgba(29,181,255,1);
		line-height:23px;
	}
	.chartsDoc{
		width:1035px;
		height:344px;
		padding: 10px 20px;
		background:rgba(255,255,255,1);
		border-radius:3px;
		
	}
	.chartsDocheader{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.chartsDocheader>div:nth-child(1){
		width: 400px;
	}
	.chartsDocheader>div:nth-child(1)>div{
		width: 400px;
	}
	.datebtn>div:hover{
		border:1px solid yellow;
		
	}
	.datebtn{
		display: flex;
	}
	.datebtn>div{
		margin-right: 13px;
		cursor: pointer;
		width:93px;
		height:42px;
		background:rgba(234,234,234,1);
		border-radius:24px;
		border:1px solid rgba(221,227,232,1);
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(155,155,155,1);
		line-height:24px;
		display: flex;justify-content: center;
		align-items: center;
	}
	.datebtn>div.active{
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:24px;
		background:rgba(29,181,255,1);
	}
	.chartsDoccontent{
		display: flex;
		justify-content: space-between;
	}
	.chartsDoccontent>div{
		width:497px;
		height: 290px;
		margin-top: 10px;
		/*background: #CCCCCC;*/
	}
	
</style>


// WEBPACK FOOTER //
// src/component/mzEcharts.vue